export const VideoToggle = (function () {
	'use strict';

	function init() {
		const $buttons = document.querySelectorAll('[data-video-toggle]')
		$buttons.forEach(($button) => {
			const $video = $button.parentNode.querySelector('video')
			if ($video) {
				$button.addEventListener('click', (ev) => {
					if ($video.paused) {
						$video.play()
						$button.innerHTML = 'Pause Video'
						$button.classList.remove('paused')
					} else {
						$video.pause()
						$button.innerHTML = 'Play Video'
						$button.classList.add('paused')
					}
				}, { passive: true })

			}
		})
	}

	return {
		init: init,
	};
})();
